import React, { useEffect } from "react";

/**
 * Minimal callback page for Google OAuth.
 * Google redirects here with ?code=xxx.
 * We store the code in localStorage (triggers 'storage' event in the main tab)
 * and close this tab.
 */
const GoogleCallbackPage = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const error = params.get("error");
    // OAuth `state` (the API requires it on POST /callback since 2026-10-22) and
    // Google's `error` (e.g. access_denied) are handed to the waiting tab too.
    // The state is written BEFORE the code: the listener acts on the code.
    try {
      localStorage.removeItem("gcal-auth-error");
      const state = params.get("state");
      if (state) localStorage.setItem("gcal-auth-state", state);
      else localStorage.removeItem("gcal-auth-state");
    } catch {
      // storage blocked — nothing can be handed over anyway
    }

    // Dashboard v2: when its pop-up was blocked the consent screen ran in the
    // main tab and left a return path — go back there (it finishes the exchange
    // from the stored code) instead of trying to close the only tab.
    let returnTo = null;
    try {
      returnTo = !window.opener ? localStorage.getItem("gcal-return-to") : null;
      localStorage.removeItem("gcal-return-to");
    } catch {
      returnTo = null;
    }
    const safeReturn = returnTo && returnTo.startsWith("/") && !returnTo.startsWith("//") ? returnTo : null;

    if (code) {
      localStorage.setItem("gcal-auth-code", code);
      if (safeReturn) {
        window.location.replace(safeReturn);
        return;
      }
      // Give the storage event time to fire in the other tab, then close
      setTimeout(() => window.close(), 500);
    } else if (error) {
      try {
        localStorage.setItem("gcal-auth-error", error);
      } catch {
        // storage blocked
      }
      if (safeReturn) {
        window.location.replace(safeReturn);
        return;
      }
      // User denied or error
      setTimeout(() => window.close(), 1000);
    }
  }, []);

  return (
    <div style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100vh",
      background: "#0e0e0e",
      color: "#b7b7b7",
      fontFamily: "Inter, sans-serif",
      fontSize: "14px",
    }}>
      <p>Connecting Google Calendar... This tab will close automatically.</p>
    </div>
  );
};

export default GoogleCallbackPage;
